import { login, logout, getInfo } from "@/api/user";
import { getToken, setToken } from "@/utils/auth";
import router, { resetRouter, constantRoutes } from "@/router";

const state = {
  token: getToken(),
  name: "",
  avatar: "",
  usid: "",
  enpid: "",
  enterpriseName: "",
  enterpriseEnName: "",
  introduction: "",
  realroles: [],
  isadmin: "",
  roles: [],
  menus: [],
  permissions: [],
  usname: "",
  seekMaterialDataSheetFlag: true, //为了点击菜单可回到初始页，加的状态符号,true和false并无其他意义
  routerParams: {},
  nextShow: 1,
  dataTheme:'blue',
  statusFlag: 1, //状态字段，承诺书中权限使用到了
  receiveMdsPageCheckListBox:['serialnumber','mdsType','mdsName','cid', 'symbol', 'acceptDate', 'approveDate', 'sendOrg', 'sendOrgID', 'status', 'commitment'],
  sendMdsPageCheckListBox:['Serialnumber','mdsType','name','version','code','csymbol','sendTime','sendOrg','status'],
  pubKey:
    "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANZk/zWQZAWq7NqshVx0luQgGmvKtrkVxNsU/KU/bW2JDDcvY/3thKHHskD8K9iFyUAoZVNrGgYVWIFn+YRYR68CAwEAAQ==",
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USID: (state, usid) => {
    state.usid = usid;
  },
  SET_USNAME: (state, usname) => {
    state.usname = usname;
  },
  SET_RECEIVEMDSPAGECHECKLISTBOX: (state, receiveMdsPageCheckListBox) => {
    state.receiveMdsPageCheckListBox = receiveMdsPageCheckListBox;
  },
  SET_SENDMDSPAGECHECKLISTBOX: (state, sendMdsPageCheckListBox) => {
    state.sendMdsPageCheckListBox = sendMdsPageCheckListBox;
  },
  SET_DATATHEME: (state, dataTheme) => {
    state.dataTheme = dataTheme;
  },
  SET_ENPID: (state, enterprsieId) => {
    state.enpid = enterprsieId;
  },
  SET_ENTERPRISENAME: (state, enterpriseName) => {
    state.enterpriseName = enterpriseName;
  },
  SET_ENTERPRISEENNAME: (state, enterpriseEnName) => {
    state.enterpriseEnName = enterpriseEnName;
  },
  SET_ROUTERPARAMS: (state, routerParams) => {
    state.routerParams = routerParams;
  },
  SET_SEEKMATERIALDATASHEETFLAG: (state, routerParams) => {
    state.seekMaterialDataSheetFlag = !state.seekMaterialDataSheetFlag;
  },
  SET_MENUS: (state, menus) => {
    state.menus = menus;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_REALROLES: (state, realroles) => {
    state.realroles = realroles;
  },
  SET_ISADMIN: (state, isadmin) => {
    state.isadmin = isadmin;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
  SET_NEXTSHOW: (state, nextShow) => {
    state.nextShow = nextShow;
  },
  SET_STATUSFLAG: (state, statusFlag) => {
    state.statusFlag = statusFlag;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({
        username: username.trim(),
        password: password,
      })
        .then((response) => {
          const { data } = response;
          commit("SET_TOKEN", data.token);
          setToken(data.token);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then((response) => {
          const { data } = response;

          if (!data) {
            reject("Verification failed, please Login again.");
          }

          const { realroles, isadmin, roles, name, avatar, introduction } =
            data;

          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            reject("getInfo: roles must be a non-null array!");
          }
          commit("SET_REALROLES", realroles);
          commit("SET_ISADMIN", isadmin);
          commit("SET_ROLES", roles);
          commit("SET_NAME", name);
          commit("SET_AVATAR", avatar);
          commit("SET_INTRODUCTION", introduction);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(["退出登录", ""])
        .then(() => {
          commit("SET_MENUS", []);
          commit("SET_USID", '');
          resetRouter();
          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          dispatch("tagsView/delAllViews", null, {
            root: true,
          });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      resolve();
    });
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + "-token";

    commit("SET_TOKEN", token);
    setToken(token);

    const { roles } = await dispatch("getInfo");

    resetRouter();

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch("permission/generateRoutes", roles, {
      root: true,
    });
    // dynamically add accessible routes
    router.addRoutes(accessRoutes);

    // reset visited views and cached views
    dispatch("tagsView/delAllViews", null, {
      root: true,
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
